<template>
  <base-dialog v-model="visible" width="480px" class="save-confirm" type="warning" append-to-body title="更改未保存，是否退出页面？">
    <div class="save-confirm__content">
      <div class="text-center text-white text-16 mb-[30px] mt-4">离开此页面将删除所有未保存的更改。</div>
      <div class="flex justify-end gap-4">
        <base-button @click.stop="close">留下</base-button>
        <base-button type="danger" @click.stop="handleQuit">离开页面</base-button>
      </div>
    </div>
  </base-dialog>
</template>

<script>
import BaseDialog from "~/components/base/baseDialog.vue";
import BaseButton from "~/components/base/BaseButton.vue";

export default {
  name: 'SaveConfirm',
  components: {
    BaseDialog,
    BaseButton
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    init() {
      this.visible = true
    },
    close() {
      this.visible = false
    },
    handleQuit() {
      this.$emit('back')
    }
  }
}
</script>